import * as React from 'react';
import './index.scss';
import reward_0 from '@images/rule/reward_0.png';
import reward_3 from '@images/rule/reward_3.png';

import reward_1_1 from '@images/rule/reward_1-1.png';
import reward_1_2 from '@images/rule/reward_1-2.png';
import reward_1_3 from '@images/rule/reward_1-3.png';

import reward_2_1 from '@images/rule/reward_2-1.png';
import reward_2_2 from '@images/rule/reward_2-2.png';
import reward_2_3 from '@images/rule/reward_2-3.png';

import rule_2 from '@images/rule/rule_2.png';
import rule_3 from '@images/rule/rule_3.png';
import rule_4 from '@images/rule/rule_4.png';
import rule_5 from '@images/rule/rule_5.png';

const { useState } = React;

const Tab4: React.FC = () => {
  const [current, Current] = useState<number>(0);
  return (
    <div className='tab4'>
      <div className={`rule_reward rule_reward_${current}`}>
        <ul>
          {
            ['年度全明星奖励', '五大电竞明星', '五大国民偶像'].map((item: string, index: number) => (
              <li
                key={item}
                className={index === current ? 'on' : ''}
                onClick={() => Current(index)}
              >{item}</li>
            ))
          }
        </ul>
        {
          current === 0 && <img src={reward_0} />
        }
        {
          current === 3 && <img src={reward_3} />
        }
        {
          current === 1 && (
            <>
              <img src={reward_1_1} />
              <img src={reward_1_2} />
              <img src={reward_1_3} />
            </>
          )
        }
        {
          current === 2 && (
            <>
              <img src={reward_2_1} />
              <img src={reward_2_2} />
              <img src={reward_2_3} />
            </>
          )
        }
      </div>
      <img src={rule_2} />
      <img src={rule_3} />
      <img src={rule_4} />
      <img src={rule_5} />
    </div>
  )
}

export default Tab4;